// app/frontend/router/routes.js
export default [
  {
    path: '/login',
    name: 'login',
    component: () => import('../pages/LoginPage.vue'),
    meta: { guest: true },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../pages/RegisterPage.vue'),
    meta: { guest: true },
  },
  {
    path: '/',
    name: 'landing',
    component: () => import('../pages/LandingPage.vue'),
    meta: { guest: true },
  },
  {
    path: '/lobby',
    name: 'lobby',
    component: () => import('../pages/GameLobby.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/game/:id',
    name: 'game',
    component: () => import('../pages/GameView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../pages/NotFound.vue'),
  },
]
